module.exports = __webpack_public_path__ + "static/img/USC_Marshall_CurriculumMap_2023_ACCT_R3.a10dec6.png";


//////////////////
// WEBPACK FOOTER
// ./static/USC_Marshall_CurriculumMap_2023_ACCT_R3.png
// module id = JhfJ
// module chunks = 1